import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MarkdownModule } from 'ngx-markdown';
import { WingsAssistantChatComponent } from './wings-assistant-chat';
import { WingsConversationListComponent } from './wings-conversation-list.component';
import { WingsChatHeaderComponent } from './wings-chat-header';
import { WingsMessageComponent } from './components/wings-message/wings-message.component';
import { WingsFeedbackModalComponent } from './components/wings-feedback-modal/wings-feedback-modal.component';

@NgModule({
  declarations: [
    WingsAssistantChatComponent,
    WingsConversationListComponent,
    WingsChatHeaderComponent,
    WingsMessageComponent,
    WingsFeedbackModalComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    MarkdownModule.forChild()
  ],
  exports: [
    WingsAssistantChatComponent
  ]
})
export class WingsAssistantChatModule { }
